import { Raycaster, Vector2 } from "three";

export function bindPartSelection(canvas, { getScene, getCamera, getNodes, isEnabled, isTransforming, onSelect }) {
    const raycaster = new Raycaster(), pointers = new Set();
    let down = null;
    const cancel = event => { pointers.delete(event.pointerId); down = null; };
    const handlers = {
        pointerdown(event) {
            pointers.add(event.pointerId);
            // TransformControls handles pointerdown first. Remember that a
            // handle owns this gesture even after its pointerup ends the drag.
            down = pointers.size === 1 && event.button === 0 && isEnabled() && !isTransforming()
                ? { id: event.pointerId, x: event.clientX, y: event.clientY } : null;
        },
        pointermove(event) {
            if (down && (isTransforming() || Math.hypot(event.clientX - down.x, event.clientY - down.y) > 4)) down = null;
        },
        pointercancel: cancel,
        lostpointercapture: cancel,
        pointerup(event) {
            const start = down; down = null; pointers.delete(event.pointerId);
            const scene = getScene();
            if (!start || start.id !== event.pointerId || !isEnabled() || isTransforming() || !scene
                || Math.hypot(event.clientX - start.x, event.clientY - start.y) > 4) return;
            const bounds = canvas.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;
            const indices = new Map([...(getNodes() ?? [])].map(([index, object]) => [object, index]));
            raycaster.setFromCamera(new Vector2((event.clientX - bounds.left) / bounds.width * 2 - 1,
                -(event.clientY - bounds.top) / bounds.height * 2 + 1), getCamera());
            for (const hit of raycaster.intersectObject(scene, true)) {
                let visible = true;
                for (let object = hit.object; object; object = object.parent) if (!object.visible) { visible = false; break; }
                if (!visible) continue;
                for (let object = hit.object; object; object = object.parent) {
                    if (!indices.has(object)) continue;
                    onSelect?.(indices.get(object), event.ctrlKey || event.metaKey || event.shiftKey);
                    return;
                }
            }
        }
    };
    for (const [type, handler] of Object.entries(handlers)) canvas.addEventListener(type, handler);
    return () => { for (const [type, handler] of Object.entries(handlers)) canvas.removeEventListener(type, handler); };
}
